import * as React from 'react';
import Radio from "antd/lib/radio";
import message from "antd/es/message";
import { getMapStyles } from './MapBoxConfig';

interface MapStyleSwitcherProps {
  mapObject: any;
  accessToken: string;
  mapStyle: string;
  onSwitchStyle: Function;
  public?: boolean;
}

const BASE_STYLE_SOURCES = new Set([
  'mapbox://mapbox.mapbox-streets-v8',
  'mapbox://mapbox.satellite',
  'mapbox://mapbox.streets',
  'mapbox',
  'composite',
]);

export default function MapStyleSwitcher(props: MapStyleSwitcherProps) {
  const { mapObject, accessToken, mapStyle, onSwitchStyle } = props;
  const availableMapStyles = getMapStyles();

  const switchBaseMap = async (styleID: any) => {
    try {
      const response = await fetch(
        `https://api.mapbox.com/styles/v1/mapbox/${styleID}?access_token=${accessToken}`
      );

      if (!response.ok) {
        throw new Error(`the base map could not be read (${response.status})`);
      }

      const newStyle = await response.json();

      const currentStyle = mapObject.getStyle();

      newStyle.sources = Object.assign(
        {},
        currentStyle.sources,
        newStyle.sources
      );

      // Carry over only app-defined layers (not base style tile layers).
      const appLayers = currentStyle.layers.filter((el: any) => {
        return (
          el.source &&
          !BASE_STYLE_SOURCES.has(el.source) &&
          el.source !== 'composite'
        );
      });

      newStyle.layers = [
        ...newStyle.layers,
        ...appLayers,
      ];

      mapObject.setStyle(newStyle);

      onSwitchStyle && onSwitchStyle();
    } catch (error) {
      // The map keeps the style it has: a base map that could not be read must not leave it blank
      console.error('could not switch the base map', { styleID, error });
      message.error('The map style could not be loaded');
    }
  }

  return (
    <Radio.Group
      options={Object.keys(availableMapStyles)}
      onChange={({ target: { value } }) => {
        // @ts-ignore
        switchBaseMap(availableMapStyles[value]);
      }}
      value={mapStyle}
      optionType="button"
      buttonStyle="solid"
    />
  );
}
